module.exports = __webpack_public_path__ + "img/GreekTechHippikonS_ua.65f56f1a.webp";